import axios from "axios";
const uri = "https://www.lefisc.com.br/api/apiRegulamentos";
const tok = "64ad62a25fe48a9e8bcd84df737dd40b";

export default{
    getAll(regulamento){
        return axios
            .get(`${uri}/allProdutos/buscaMenu/${regulamento}/${tok}`)
            .then(res => {
                return res.data;
            })
            .catch(err => console.error(err));
    },
    getFiltrado(regulamento,texto){
        return axios
            .get(`${uri}/allProdutos/buscaMenu/${regulamento}/${texto}/${tok}`)
            .then(res => {
                return res.data;
            })
            .catch(err => console.error(err));
    },
    getConteudo(regulamento){
        return axios
            .get(`${uri}/allProdutos/buscaConteudo/${regulamento}/${tok}`)
            .then(res => {
                return res.data;
            })
            .catch(err => console.error(err));
    },
    getProduto(regulamento){
        return axios
            .get(`${uri}/allProdutos/buscaProduto/${regulamento}/${tok}`)
            .then(res => {
                return res.data;
            })
            .catch(err => console.error(err));
    },
    getMenuApoio(regulamento){
        return axios
            .get(`${uri}/allProdutos/buscaMenuApoio/${regulamento}/${tok}`)
            .then(res => {
                return res.data;
            })
            .catch(err => console.error(err));
    }
} 


// WEBPACK FOOTER //
// ./src/services/serviceRegulamentos.js